import { Second } from 'web-utility';
import io from 'socket.io-client';
import { IStreamProvider } from '../interface';
import {
  Bar,
  LibrarySymbolInfo,
  SubscribeBarsCallback
} from '../../../../static/charting_library/charting_library.min';
import { ExampleHistoryProvider } from './HistoryProvider';

var socket_url = 'wss://streamer.cryptocompare.com';
var socket = io(socket_url);
// keep track of subscriptions
var _subs: any = [];
var xResolution: any = 15;
var symbolInfoname: string = 'BTC/USD';

var newSub = {};
export class ExampleStreamProvider implements IStreamProvider {
  unsubscribeBars(listenerGuid: string): void {
    var subIndex = _subs.findIndex(e => e.uid === listenerGuid);
    if (subIndex === -1) {
      //console.log("No subscription found for ",uid)
      return;
    }
    var sub = _subs[subIndex];
    socket.emit('SubRemove', { subs: [sub.channelString] });
    _subs.splice(subIndex, 1);
  }
  subscribeBars = (
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    onRealtimeCallback: SubscribeBarsCallback,
    listenerGuid: string,
    onResetCacheNeededCallback: () => void
  ) => {
    const channelString = createChannelString(symbolInfo);
    socket.emit('SubAdd', { subs: [channelString] });
    xResolution = resolution;
    symbolInfoname = symbolInfo.name;
    newSub = {
      channelString,
      listenerGuid,
      resolution,
      symbolInfo,
      listener: onRealtimeCallback
    };
    _subs.push(newSub);
  };
}

socket.on('connect', () => {
  console.log('===Socket connected');
});
socket.on('disconnect', e => {
  console.log('===Socket disconnected:', e);
});
socket.on('error', err => {
  console.log('====socket error', err);
});
socket.on('m', e => {
  // here we get all events the CryptoCompare connection has subscribed to
  // we need to send this new data to our subscribed charts
  const _data = e.split('~');
  console.log('_data', _data);
  if (_data[0] === '401' || _data[0] === '500') {
    setInterval(async () => {
      const historyProvider = new ExampleHistoryProvider();
      const bars = await historyProvider.getBars(
        { name: symbolInfoname },
        xResolution,
        '',
        null,
        1
      );
      const [to_sym, from_sym] = symbolInfoname.split(/[:/]/);

      const newdata = {
        from_sym,
        to_sym,
        time: bars[bars.length - 1].time,
        volume: bars[0].volume,
        price: bars[bars.length - 1].close
      };
      const channelString = `0~${to_sym}~${from_sym}`;

      const subX = _subs.find(e => e.channelString === channelString);

      if (!subX || newdata.time < subX.lastBar.time / 1000) return;

      const _lastBarX = updateBar(newdata, subX);
      console.log(_lastBarX);
      subX.listener(_lastBarX);
      subX.lastBar = _lastBarX;
    }, Second * 10);
  }
  if (_data[0] === '3') {
    // console.log('Websocket Snapshot load event complete')
    return;
  }
  let data = {
    sub_type: parseInt(_data[0], 10),
    exchange: _data[1],
    to_sym: _data[2],
    from_sym: _data[3],
    trade_id: _data[5],
    time: parseInt(_data[6], 10),
    volume: parseFloat(_data[7]),
    price: parseFloat(_data[8])
  };

  let channelString = `${data.sub_type}~${data.exchange}~${data.to_sym}~${data.from_sym}`;
  const sub = _subs.find(e => e.channelString === channelString);
  console.log('sub', sub);
  if (sub) {
    // disregard the initial catchup snapshot of trades for already closed candles
    if (data.time < sub.lastBar.time / 1000) {
      return;
    }
    var _lastBar = updateBar(data, sub);
    console.log(_lastBar);
    // send the most recent bar back to TV's realtimeUpdate callback
    sub.listener(_lastBar);
    // update our own record of lastBar
    sub.lastBar = _lastBar;
  }
});

// Take a single trade, and subscription record, return updated bar
function updateBar(data, sub) {
  var lastBar = sub.lastBar;
  let resolution = sub.resolution;
  if (resolution.includes('D')) {
    // 1 day in minutes === 1440
    resolution = 1440;
  } else if (resolution.includes('W')) {
    // 1 week in minutes === 10080
    resolution = 10080;
  }
  var coeff = resolution * 60;
  var rounded = Math.floor(data.time / coeff) * coeff;
  var lastBarSec = lastBar.time / 1000;
  var _lastBar;
  if (rounded > lastBarSec) {
    // create a new candle, use last close as open **PERSONAL CHOICE**
    _lastBar = {
      time: rounded * 1000,
      open: lastBar.close,
      high: lastBar.close,
      low: lastBar.close,
      close: data.price,
      volume: data.volume
    };
  } else {
    // update lastBar candle!
    if (data.price < lastBar.low) {
      lastBar.low = data.price;
    } else if (data.price > lastBar.high) {
      lastBar.high = data.price;
    }
    lastBar.volume += data.volume;
    lastBar.close = data.price;
    _lastBar = lastBar;
  }
  return _lastBar;
}
// takes symbolInfo object as input and creates the subscription string to send to CryptoCompare
function createChannelString(symbolInfo) {
  var channel = symbolInfo.name.split(/[:/]/);
  // const exchange = channel[0] === 'GDAX' ? 'Coinbase' : channel[0]
  const from = channel[0];
  const to = channel[1];
  // subscribe to the CryptoCompare trade channel for the pair and exchange
  return `0~${from}~${to}`;
}
